// @mui material components
import Card from "@mui/material/Card";
import React, { useEffect, useState } from "react";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkIcon from "@mui/icons-material/Link";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import checkboxgreen from "assets/images/logos/checkboxgreen.png";
import checkboxwhite from "assets/images/logos/checkboxwhite.png";
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import useStore from "store/hook";
import InspectionSection from "./components/InspectionSection";
import headerBg from "assets/images/curved-images/Header.png";
import SoftAvatar from "components/SoftAvatar";
import api from "store/api/api";
import formatStringWithSpaces from "../../services/stringconverter";
import getTimeFromMilliseconds from "../../services/timeconverter";
import truncateString from "services/truncatestring";
import DeleteInspection from "components/SoftDialog/DeleteInspection";
import { Grid, Menu, MenuItem, Radio, TextField } from "@mui/material";
import Discipline from "./components/Discipline";
import SelectDicipline from "components/SoftDialog/SelectDicipline";
import AddDicipline from "components/SoftDialog/AddDicipline";
import PredefinedComment from "components/SoftDialog/PredefinedComment";
import AddLocation from "components/SoftDialog/AddLocation";
import SelectInspection from "components/SoftDialog/SelectInspection";
import formatPhoneNumber from "services/formatPhoneNo";
import convertMillisecondsToDate from "services/dateconverter";
import AddIcon from "@mui/icons-material/Add";
import ResponsiveTimePickers from "./components/TimePicker";
import { toast } from "react-toastify";
import { uploadImages } from "services/firebase";
import CircularLoader from "components/SoftDialog/Loader";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DateTimePicker from "./components/DateTimePicker";
import getDateFromSeconds from "services/getDate";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import AddSiteRepresentative from "components/SoftDialog/AddSiteRepresentative";
import { FaPlus } from "react-icons/fa";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import InspectorList from "./components/InspectorList";
import SoftInput from "components/SoftInput";

function UpdateInspection() {
  const { setDialogue } = useStore();
  const navigate = useNavigate();
  const { id } = useParams();
  const [mainLoading, setMainLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inspectionData, setInspectionData] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [links, setLinks] = useState([]);
  const [manager, setManager] = useState([]);
  const [contacts, setContact] = useState([]);
  const [discipline, setDiscipline] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [referenceData, setReferenceData] = useState({});
  const [pfiCorrected, setPifCorrected] = useState(false);
  const [replacePif, setReplacePif] = useState(false);
  const [inspectionDetails, setInspectionDetails] = useState({
    reInspection: "",
    reportNumber: "",
    weather: "",
    temperature: "",
    arrivedTime: "",
    leftTime: "",
    deficiencyFound: [],
    discipline: [],
    site_representative: [],
    inner_status: "",
    createdTime: "",
    inspectionTime: "",
    inspection_number: "",
    inspection_discipline_start: "",
    inspector_data: {
      name: "",
      image: "",
      id: "",
    },
    pif_type: "",
    pif_value: "",
    updated_inspector: "jkfdjfdjfie",
  });

  let lastFailedRequest1 = false;
  let lastFailedRequest2 = false;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData"));

    if (!loginData) {
      navigate("/authentication/signin");
    } else {
      fetchInspectionDetails();
    }
  }, [navigate, id]);

  const fetchInspectionDetails = async () => {
    setMainLoading(true);
    try {
      const response = await api.getInspectionDetails({
        inspection_id: id,
      });

      if (response?.data?.is_deleted) {
        navigate("/inspections");
      }

      setInspectionDetails({
        reInspection: response?.data?.is_reinspection,
        reportNumber: response?.data?.report_number,
        weather: response?.data?.weather_condition,
        temperature: response?.data?.temperature,
        arrivedTime: response?.data?.arrival_time,
        leftTime: response?.data?.time_left,
        deficiencyFound: response?.data?.deficiencies_found,
        discipline: response?.data?.discipline_data,
        site_representative: response?.data?.app_site_representative,
        inner_status: response?.data?.inner_status,
        createdTime: response?.data?.createdTime,
        inspectionTime: response?.data?.inspectionTime,
        inspection_number: response?.data?.inspection_number,
        inspector_data: response?.data?.updated_inspector?._id
          ? {
              name: response?.data?.updated_inspector?.full_name,
              image: response?.data?.updated_inspector?.profile_picture,
              id: response?.data?.updated_inspector?._id,
            }
          : {
              name: response?.data?.added_by?.full_name,
              image: response?.data?.added_by?.profile_picture,
              id: response?.data?.added_by?._id,
            },
        pif_type: response?.data?.pif_type,
        pif_value: response?.data?.pif_value,
        inspection_discipline_start: response.data?.inspection_discipline_start,
      });

      setInspectionData(response?.data);
      setProjectData(response?.data?.projectDetail);
      setLinks(response?.data?.projectDetail?.links);
      setManager(response?.data?.projectDetail?.manager);
      setContact(response?.data?.projectDetail?.site_contacts);
      setDiscipline(response?.data?.discipline_data);
      setReferenceData(response?.data?.refferenceData);
      setPifCorrected(response?.data?.pif_type == "corrected_pif");
      setReplacePif(response?.data?.pif_type == "replace_pif");
    } catch (error) {
      lastFailedRequest1 = true;
      toast.error("Oops! slow network or server issue. Please try again.");
      console.error("Error in fetching details", error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleOpenSelectInspection = () => {
    setDialogue({
      type: "selectInspection",
      isOpen: true,
      inspectionId: "",
      action: "updateInspection",
    });
  };

  const handleOpenDiciplineSelect = (index) => {
    setDialogue({
      type: "selectDicipline",
      isOpen: true,
      selectedDicipline: index,
      action: "updateInspection",
      isAdddiscipline: true,
    });
  };

  const handleUploadImage = async () => {
    // Map through each discipline
    const updatedDiscipline = await Promise.all(
      discipline.map(async (item) => {
        // Separate existing URLs and local files
        const existingUrls = (item.images || []).filter(
          (img) => typeof img === "string"
        );
        const filesToUpload = (item.images || []).filter(
          (img) => typeof img !== "string"
        );

        // Upload new local files to Firebase
        const uploadedUrls = await uploadImages(filesToUpload);

        // Append newly uploaded URLs to existing ones
        return {
          ...item,
          images: [...existingUrls, ...uploadedUrls],
        };
      })
    );

    return updatedDiscipline;
  };

  const handleUpdateInspection = async () => {
    try {
      setIsLoading(true);

      if (
        (inspectionDetails?.reInspection == "yes" &&
          inspectionDetails?.pif_type !== "" &&
          inspectionDetails?.pif_value == "") ||
        ""
      ) {
        toast.error("Please enter the PIF number");
        setIsLoading(false);
        return;
      }

      if (inspectionDetails?.leftTime <= inspectionDetails?.arrivedTime) {
        toast.error("Left time must be greater than arrival time");
        setIsLoading(false);
        return;
      }

      if (inspectionDetails?.temperature == "") {
        toast.error("Please enter the temperature");
        setIsLoading(false);
        return;
      }

      if (inspectionDetails?.site_representative?.length <= 0) {
        toast.error(
          "Please add at least one site representative before proceeding."
        );
        return;
      }

      if (discipline.length <= 0) {
        toast.error("Please add the disciplie data");
        setIsLoading(false);
        return;
      }

      const newDisciplineData = await handleUploadImage();

      const discipline_data_sent =
        newDisciplineData && newDisciplineData.length > 0
          ? JSON.stringify(newDisciplineData)
          : "";

      const response = await api.editInspection({
        status: inspectionData?.status || "",
        inspection_id: inspectionData?._id || "",
        deficiencies_found:
          JSON.stringify(inspectionDetails?.deficiencyFound) || "",
        weather_condition: inspectionDetails?.weather || "",
        report_number: "",
        temperature: inspectionDetails?.temperature || "",
        arrival_time: inspectionDetails?.arrivedTime || "",
        time_left: inspectionDetails?.leftTime || "",
        is_reinspection: inspectionDetails?.reInspection || "",
        inspection_refference_id: referenceData?._id || "",
        discipline_data: discipline_data_sent,
        inspectionTime: inspectionDetails?.inspectionTime || "",
        inner_status: inspectionDetails?.inner_status,
        inspection_number: inspectionDetails?.inspection_number || "",
        updated_inspector: inspectionDetails?.updated_inspector || "",
        pif_type: inspectionDetails?.pif_type || "",
        pif_value: inspectionDetails?.pif_value || "",
        app_site_representative: JSON.stringify(
          inspectionDetails?.site_representative
        ),
      });

      if (response?.status == 1) {
        navigate(`/inspection-overview/${inspectionData?._id}`);
        toast.success("Inspection updated successfully");
      } else {
        const modifiedMessage = formatStringWithSpaces(response?.message);
        toast.error(modifiedMessage);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error("Oops! Slow network or server issue. Please try again.");
      lastFailedRequest2 = true;
    } finally {
      setIsLoading(false);
    }
  };

  const handleMenuItemClick = (selectedWeather) => {
    setInspectionDetails((prev) => ({
      ...prev,
      weather: selectedWeather,
    }));
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDeleteSiteRepresentative = (index) => {
    setInspectionDetails((prev) => ({
      ...prev,
      site_representative: prev.site_representative.filter(
        (item, i) => i !== index
      ),
    }));
  };

  const handleUpdateSiteRepresentative = (index) => {
    setDialogue({
      type: "addSiteRepresentative",
      isOpen: true,
      action: "editSiteRepresentative",
      name: inspectionDetails?.site_representative[index].name,
      companyName: inspectionDetails?.site_representative[index].companyName,
      index: index,
      isEdit: true,
    });
  };

  window.addEventListener("online", () => {
    if (lastFailedRequest2) {
      handleUpdateInspection();
      lastFailedRequest2 = false;
    }

    if (lastFailedRequest1) {
      fetchInspectionDetails();
      lastFailedRequest1 = false;
    }
  });

  // handle clear pif numbers
  const handleClearPif = () => {
    setPifCorrected(false);
    setReplacePif(false);
    setInspectionDetails((prev) => ({
      ...prev,
      pif_type: "",
      pif_value: "",
    }));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddSiteRepresentative setInspectionDetails={setInspectionDetails} />
      <DeleteInspection type="inspection" />
      <ResponsiveTimePickers
        inspectionDetails={inspectionDetails}
        setInspectionDetails={setInspectionDetails}
      />

      <DateTimePicker
        inspectionDetails={inspectionDetails}
        setInspectionDetails={setInspectionDetails}
      />

      <Discipline />

      <SoftBox py={1}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              sx={{
                backgroundColor: "primary.main",
                backgroundImage: `url(${headerBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              px={{ xs: 2, md: 3 }}
              py={2.5}
            >
              <SoftTypography color="white" variant="h6" fontSize="20px">
                <Link to="/inspections" style={{ color: "white" }}>
                  <SoftTypography
                    component="span"
                    fontWeight="light"
                    variant="h6"
                    fontSize="20px"
                  >
                    Inspections &gt;{" "}
                  </SoftTypography>
                </Link>
                Edit Inspection
              </SoftTypography>
            </SoftBox>

            {mainLoading ? (
              <SoftBox
                display="flex"
                height="calc(100vh - 180px)"
                justifyContent="center"
                alignItems="center"
                p={3}
              >
                <SoftTypography variant="subtitle1" color="textSecondary">
                  <CircularLoader type="large" />
                </SoftTypography>
              </SoftBox>
            ) : (
              <SoftBox>
                <SoftBox
                  px={{ xs: 2, md: 3 }}
                  py={2}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                  justifyContent="space-between"
                >
                  <SoftBox
                    display="flex"
                    flexDirection="column"
                    gap={1}
                    sx={{
                      pr: {
                        sm: 5,
                      },
                    }}
                  >
                    <SoftTypography
                      color="info"
                      fontWeight="bold"
                      fontSize="36px"
                      textTransform="capitalize"
                    >
                      {projectData?.name}-{projectData?.project_number}
                    </SoftTypography>

                    <SoftBox
                      sx={{
                        backgroundColor: "#F1F4F8",
                        borderRadius: "8px",
                        padding: "8px 12px",
                        marginBottom: "4px",
                        width: "100%",
                      }}
                    >
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ minWidth: { md: 600 } }}
                        gap="8px"
                      >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                          <SoftTypography
                            fontSize="16px"
                            color="lightblack"
                            textTransform="capitalize"
                            fontWeight="bold"
                          >
                            Inspection:
                          </SoftTypography>
                          <SoftTypography
                            fontSize="16px"
                            color="primary"
                            textTransform="capitalize"
                            fontWeight="medium"
                          >
                            {inspectionData?.inspection_number}-
                            {inspectionData?.inspection_discipline_start}
                          </SoftTypography>
                        </SoftBox>

                        <SoftTypography
                          fontSize="16px"
                          color="primary"
                          textTransform="capitalize"
                          fontWeight="medium"
                        >
                          {convertMillisecondsToDate(
                            inspectionDetails?.createdTime
                          )}{" "}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    <SoftBox
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: { xs: 2, sm: 8 },
                      }}
                    >
                      <SoftBox>
                        <SoftTypography
                          color="lightBlack"
                          fontSize="20px"
                          fontWeight="bold"
                        >
                          Project Manager
                        </SoftTypography>

                        <SoftTypography
                          color="lightBlack"
                          fontSize="16px"
                          display="flex"
                          gap={2}
                          textTransform="capitalize"
                          sx={{}}
                        >
                          {manager?.length > 0
                            ? manager?.map((manager, index) => (
                                <Link
                                  to={`/inspector-overview/${manager?._id}`}
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  <SoftBox
                                    key={index}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      gap: "3px",
                                      transition: "background-color 0.3s",
                                    }}
                                  >
                                    <SoftAvatar
                                      src={manager?.profile_picture || ""}
                                      alt="profile Image"
                                      size="sm"
                                      variant="rounded"
                                    />
                                    <SoftTypography
                                      className="inspector-name"
                                      variant="text"
                                      fontSize="14px"
                                      color="#212121"
                                      textTransform="capitalize"
                                    >
                                      {truncateString(manager?.full_name, 25)}
                                    </SoftTypography>
                                  </SoftBox>
                                </Link>
                              ))
                            : ""}
                        </SoftTypography>
                      </SoftBox>

                      <SoftBox>
                        <SoftTypography
                          color="lightBlack"
                          fontSize="20px"
                          fontWeight="bold"
                        >
                          Location
                        </SoftTypography>
                        <SoftTypography
                          color="lightBlack"
                          fontSize="14px"
                          textTransform="capitalize"
                          mt={2}
                        >
                          {projectData?.location}
                        </SoftTypography>
                      </SoftBox>

                      {/* Inspector Details */}

                      <SoftBox
                        sx={{
                          width: {
                            xm: "100%",
                            sm: "400px",
                          },
                          borderRadius: "6px",
                        }}
                        display="flex"
                        flexDirection="column"
                        alignItems="start"
                        justifyContent="start"
                      >
                        <SoftBox>
                          <SoftTypography
                            color="lightBlack"
                            fontSize="20px"
                            fontWeight="bold"
                          >
                            Inspector Details
                          </SoftTypography>
                        </SoftBox>

                        <SoftBox
                          display="flex"
                          width="100%"
                          alignItems="center"
                          justifyContent="space-between"
                          gap={2}
                        >
                          <SoftBox>
                            <Link
                              to={`/inspector-overview/${inspectionDetails?.inspector_data?.id}`}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              <SoftBox
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                }}
                                gap={1}
                              >
                                <SoftAvatar
                                  src={
                                    inspectionDetails?.inspector_data?.image ||
                                    ""
                                  }
                                  alt="profile Image"
                                  size="sm"
                                  variant="rounded"
                                />
                                <SoftTypography
                                  className="inspector-name"
                                  variant="text"
                                  fontSize="14px"
                                  color="#212121"
                                  textTransform="capitalize"
                                >
                                  {inspectionDetails?.inspector_data?.name ||
                                    ""}
                                </SoftTypography>
                              </SoftBox>
                            </Link>
                          </SoftBox>

                          {/* change button */}
                          <SoftBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setDialogue({
                                type: "changeInspector",
                                isOpen: true,
                              });
                            }}
                          >
                            <SoftTypography
                              className="inspector-name"
                              variant="text"
                              fontSize="14px"
                              color="info"
                              textTransform="capitalize"
                              sx={{ textDecoration: "underline" }}
                            >
                              Change Inspector
                            </SoftTypography>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>

                <SoftBox
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                  gap={1}
                  px={3}
                  pb={4}
                >
                  {projectData?.internal_notes && (
                    <SoftBox
                      border="0.5px solid #000000"
                      borderRadius="6px"
                      padding="10px"
                      maxHeight="130px"
                      height="100%"
                      sx={{
                        width: "100%",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                      }}
                    >
                      <SoftTypography
                        color="lightBlack"
                        fontSize="16px"
                        fontWeight="bold"
                      >
                        Internal Notes
                      </SoftTypography>
                      <SoftTypography
                        color="lightBlack"
                        fontSize="10px"
                        fontWeight="medium"
                        paddingTop="5px"
                      >
                        {projectData?.internal_notes}
                      </SoftTypography>
                    </SoftBox>
                  )}

                  {links?.length > 0 && (
                    <SoftBox
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftTypography
                        color="lightBlack"
                        fontSize="20px"
                        fontWeight="bold"
                      >
                        Project Links
                      </SoftTypography>
                      {links?.map((link, index) => (
                        <SoftTypography
                          key={index}
                          color="primary"
                          fontSize="14px"
                          display="block" // ✅ Ensures text wraps next to the icon
                          flexWrap="wrap"
                          alignItems="start"
                          justifyContent="start"
                          sx={{
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "100%",
                          }}
                        >
                          <Link
                            to={link}
                            target="_blank"
                            sx={{ textDecoration: "none", color: "inherit" }}
                          >
                            <SoftBox
                              display="flex"
                              justifyContent="start"
                              alignItems="center"
                              sx={{ color: "primary.main", width: "fit-content", }}

                            >
                              <LinkIcon
                                sx={{
                                  color: "primary.main",
                                  marginRight: "8px",
                                  width: 16,
                                  height: 16,
                                  transform: "rotate(-40deg)",
                                  flexShrink: 0,
                                }}
                              />
                              {link}
                            </SoftBox>
                          </Link>
                        </SoftTypography>
                      ))}
                    </SoftBox>
                  )}

                  {contacts?.length > 0 && (
                    <SoftBox
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftTypography
                        color="#212121"
                        fontSize="20px"
                        fontWeight="bold"
                      >
                        Project Contacts
                      </SoftTypography>
                      {contacts?.map((contact, index) => (
                        <SoftBox
                          key={index}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            backgroundColor: "#F1F4F8",
                            borderRadius: "8px",
                            padding: "5px 8px",
                            marginBottom: "4px",
                            overflowX: "auto",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": { display: "none" },
                          }}
                        >
                          <SoftBox
                            display="flex"
                            flexDirection="column"
                            color="primary"
                          >
                            <SoftBox
                              display="flex"
                              alignItems="center"
                              justifyContent="start"
                              gap="8px"
                            >
                              <SoftTypography
                                fontSize="14px"
                                color="primary"
                                textTransform="uppercase"
                                fontWeight="medium"
                              >
                                {contact?.name}
                              </SoftTypography>

                              <SoftTypography
                                fontSize="12px"
                                color="primary"
                                textTransform="capitalize"
                                fontWeight="medium"
                              >
                                {contact?.companyName}
                              </SoftTypography>
                            </SoftBox>

                            <SoftBox display="flex" gap="8px">
                              {contact?.email && (
                                <a
                                  href={`mailto:${contact?.email}`}
                                  sx={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  <SoftBox
                                    display="flex"
                                    gap="8px"
                                    color="primary"
                                  >
                                    <EmailIcon color="primary" />
                                    <SoftTypography
                                      fontSize="14px"
                                      color="primary"
                                    >
                                      {contact?.email}
                                    </SoftTypography>
                                  </SoftBox>
                                </a>
                              )}

                              {contact?.phoneNo && (
                                <SoftBox
                                  display="flex"
                                  gap="8px"
                                  color="primary"
                                >
                                  <PhoneIcon color="primary" />
                                  <SoftTypography
                                    fontSize="14px"
                                    color="primary"
                                  >
                                    {contact?.country_code}{" "}
                                    {formatPhoneNumber(contact?.phoneNo)}
                                  </SoftTypography>
                                </SoftBox>
                              )}
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      ))}
                    </SoftBox>
                  )}
                </SoftBox>

                <SoftBox
                  px={3}
                  display="flex"
                  alignItems="center"
                  sx={{
                    flexDirection: {
                      xs: "column", // correct
                      sm: "row",
                    },
                  }}
                  justifyContent="space-between"
                >
                  <SoftBox
                    display="flex"
                    gap="2px"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <SoftBox position="relative" mt={1} mr={0.5}>
                      {inspectionDetails?.reInspection === "yes" ? (
                        <SoftBox
                          component="img"
                          src={checkboxgreen}
                          sx={{
                            width: 20,
                            height: 20,
                            objectFit: "cover",
                            borderRadius: "2px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setInspectionDetails((prev) => ({
                              ...prev,
                              reInspection: "no",
                            }));
                            setReferenceData({});
                          }}
                        />
                      ) : (
                        <SoftBox
                          component="img"
                          src={checkboxwhite}
                          sx={{
                            width: 20,
                            height: 20,
                            objectFit: "cover",
                            borderRadius: "2px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setInspectionDetails((prev) => ({
                              ...prev,
                              reInspection: "yes",
                            }))
                          }
                        />
                      )}
                    </SoftBox>

                    <SoftTypography
                      color="lightBlack"
                      fontSize="20px"
                      fontWeight="bold"
                    >
                      Is this a Re-inspection?
                    </SoftTypography>
                  </SoftBox>

                  {inspectionDetails?.reInspection === "yes" && (
                    <SoftBox
                      display="flex"
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ cursor: "pointer" }}
                      onClick={handleOpenSelectInspection}
                    >
                      <SoftTypography
                        color="primary"
                        fontSize="16px"
                        fontWeight="medium"
                      >
                        Select Failed Inspection
                      </SoftTypography>

                      <SoftTypography color="primary" sx={{ mt: "6px" }}>
                        <ChevronRightIcon
                          sx={{
                            width: 20,
                            height: 20,
                          }}
                        />
                      </SoftTypography>
                    </SoftBox>
                  )}
                </SoftBox>

                {inspectionDetails?.reInspection == "yes" && (
                  <>
                    {JSON.stringify(referenceData) !== "{}" ? (
                      <SoftBox
                        px={3}
                        display="flex"
                        mt="8px"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <SoftBox
                          border="0.5px solid #02255B"
                          borderRadius="6px"
                          padding="10px"
                          width="100%"
                          backgroundColor="#F1F4F8"
                          sx={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": { display: "none" },
                          }}
                        >
                          <SoftTypography
                            color="lightBlack"
                            fontSize="16px"
                            fontWeight="medium"
                          >
                            Inspection Detail
                          </SoftTypography>

                          <SoftBox
                            display="flex"
                            width="100%"
                            sx={{
                              flexDirection: { xs: "column", sm: "row" },
                              gap: { xs: "2px", sm: "5px" },
                            }}
                          >
                            <SoftBox display="flex" gap="3px" width="100%">
                              <SoftTypography
                                color="lightBlack"
                                fontSize="16px"
                                fontWeight="medium"
                              >
                                Inspection Number :
                              </SoftTypography>
                              <SoftTypography
                                color="lightBlack"
                                fontSize="16px"
                                fontWeight="regular"
                              >
                                {referenceData?.inspection_number}
                              </SoftTypography>
                            </SoftBox>

                            <SoftBox
                              display="flex"
                              gap="3px"
                              width="100%"
                              sx={{ padding: { sm: "5px", xs: "0px" } }}
                            >
                              <SoftTypography
                                color="lightBlack"
                                fontSize="16px"
                                fontWeight="regular"
                              >
                                {referenceData?.weather_condition},{" "}
                                {referenceData?.temperature}°F
                              </SoftTypography>
                              <SoftTypography
                                color="lightBlack"
                                fontSize="16px"
                                fontWeight="medium"
                              >
                                : Weather
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>

                          <SoftTypography
                            color="lightBlack"
                            fontSize="14px"
                            fontWeight="normal"
                          >
                            {referenceData?.deficiencies_found === "no"
                              ? "There is no deficiencies found."
                              : referenceData?.deficiencies_found === "yes"
                              ? "There is deficiencies found"
                              : formatStringWithSpaces(
                                  referenceData?.deficiencies_found.join(", ")
                                )}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    ) : (
                      <SoftBox
                        px={3}
                        display="flex"
                        mt="8px"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <SoftBox
                          border="0.5px solid #02255B"
                          borderRadius="6px"
                          padding="10px"
                          width="100%"
                          height="90px"
                          backgroundColor="#F1F4F8"
                          sx={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": { display: "none" },
                          }}
                        >
                          <SoftTypography
                            color="lightBlack"
                            fontSize="16px"
                            fontWeight="medium"
                          >
                            Inspection Detail
                          </SoftTypography>

                          <SoftTypography
                            color="lightBlack"
                            fontSize="14px"
                            fontWeight="normal"
                          >
                            You haven't selected inspection detail at the
                            moment. Please choose inspection to import data.
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    )}
                  </>
                )}

                {/* Correced pif and replace pif */}
                {inspectionDetails?.reInspection == "yes" && (
                  <SoftBox
                    display="flex"
                    py={2}
                    gap={8}
                    px={3}
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "start", sm: "center" },
                      justifyContent: { xs: "start", sm: "center" },
                      gap: { xs: 3, sm: 5, md: 8 },
                    }}
                  >
                    <SoftBox
                      width="100%"
                      display="flex"
                      justifyContent="start"
                      sx={{
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "start", sm: "center" },
                        gap: { xs: 2, sm: 5 },
                      }}
                      gap={5}
                    >
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                        gap={1}
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setPifCorrected(true);
                          setReplacePif(false);
                          setInspectionDetails((prev) => ({
                            ...prev,
                            pif_type: "corrected_pif",
                          }));
                        }}
                      >
                        <Radio checked={pfiCorrected} color="primary" />
                        <SoftTypography
                          color="lightBlack"
                          fontSize="16px"
                          fontWeight="regular"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          PIF Corrected
                        </SoftTypography>
                      </SoftBox>

                      {pfiCorrected && (
                        <SoftBox width="100%">
                          <SoftInput
                            value={inspectionDetails?.pif_value}
                            onChange={(e) => {
                              setInspectionDetails((prev) => ({
                                ...prev,
                                pif_value: e?.target?.value,
                              }));
                            }}
                            bgcolor="#fff !important"
                            border={true}
                            placeholder="Enter PIF Corrected Number"
                            color="#02255B"
                            sx={{
                              padding: "10px 12px",
                              "& .MuiInputBase-input::placeholder": {
                                color: "#02255B !important",
                                fontSize: "16px",
                                opacity: 1,
                              },
                            }}
                          />
                        </SoftBox>
                      )}

                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                        gap={1}
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setPifCorrected(false);
                          setReplacePif(true);
                          setInspectionDetails((prev) => ({
                            ...prev,
                            pif_type: "replace_pif",
                          }));
                        }}
                      >
                        <Radio checked={replacePif} color="primary" />
                        <SoftTypography
                          color="lightBlack"
                          fontSize="16px"
                          fontWeight="regular"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          Replace PIF
                        </SoftTypography>
                      </SoftBox>

                      {replacePif && (
                        <SoftBox width="100%">
                          <SoftInput
                            value={inspectionDetails?.pif_value}
                            onChange={(e) => {
                              setInspectionDetails((prev) => ({
                                ...prev,
                                pif_value: e?.target?.value,
                              }));
                            }}
                            bgcolor="#fff !important"
                            border={true}
                            placeholder="Enter Replaced PIF Number"
                            color="#02255B"
                            sx={{
                              padding: "10px 12px",
                              "& .MuiInputBase-input::placeholder": {
                                color: "#02255B !important",
                                fontSize: "16px",
                                opacity: 1,
                              },
                            }}
                          />
                        </SoftBox>
                      )}
                    </SoftBox>

                    <SoftBox
                      diaplay="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <SoftTypography
                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                        color="lightBlack"
                        fontSize="16px"
                        fontWeight="regular"
                        onClick={() => handleClearPif()}
                      >
                        Clear
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                )}

                <SoftBox
                  px={3}
                  py={2}
                  display="flex"
                  flexDirection="row"
                  gap={1.5}
                  alignItems="center"
                  justifyContent="start"
                >
                  <SoftBox
                    display="flex"
                    gap={1}
                    alignItems="center"
                    justifyContent="center"
                    onClick={() =>
                      setDialogue({
                        type: "selectInspection",
                        isOpen: true,
                        inspectionId: "",
                        action: "selectPreviousInspectionDataInUpdate",
                      })
                    }
                  >
                    <SoftTypography
                      fontSize="20px"
                      fontWeight="medium"
                      color="primary"
                      sx={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      Import Previous Report Information
                    </SoftTypography>
                    <SaveAltIcon color="primary" width="20px" />
                  </SoftBox>
                </SoftBox>

                <SoftBox
                  display="flex"
                  gap={5}
                  px={3}
                  sx={{
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <SoftBox width="100%">
                    <SoftTypography fontWeight="bold" fontSize="20px" mb={0.5}>
                      Inspection Date
                    </SoftTypography>
                    <TextField
                      value={getDateFromSeconds(
                        inspectionDetails?.inspectionTime
                      )}
                      onClick={() =>
                        setDialogue({
                          type: "openDateTimePicker",
                          isOpen: true,
                          action: "",
                        })
                      }
                      onChange={(e) =>
                        setInspectionDetails((prev) => ({
                          ...prev,
                        }))
                      }
                      name="name"
                      placeholder="Inspection date"
                      fullWidth
                      variant="outlined"
                      InputProps={{
                        sx: {
                          border: "1px solid #6A707C",
                          backgroundColor: "#FFFFFF",
                          paddingX: "14px", // Adjust left/right padding
                        },
                      }}
                      inputProps={{
                        sx: {
                          fontSize: "16px",
                          color: "#02255B",
                          paddingY: "16px",
                          minHeight: "28px",
                          "&::placeholder": {
                            opacity: 1,
                          },
                        },
                      }}
                    />
                  </SoftBox>

                  {/* Time arrival time left */}

                  <SoftBox
                    display="flex"
                    gap={5}
                    width="100%"
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                    }}
                  >
                    <SoftBox width="100%">
                      <SoftTypography
                        fontWeight="bold"
                        fontSize="20px"
                        mb={0.5}
                      >
                        Time Arrived
                      </SoftTypography>
                      <TextField
                        value={getTimeFromMilliseconds(
                          inspectionDetails?.arrivedTime
                        )}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDialogue({
                            type: "openTimePicker",
                            isOpen: true,
                            action: "arrival",
                          });
                        }}
                        name="name"
                        placeholder="Enter Arrived Time"
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          sx: {
                            border: "1px solid #6A707C",
                            backgroundColor: "#FFFFFF",
                            paddingX: "14px", // Adjust left/right padding
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: "16px",
                            color: "#02255B",
                            paddingY: "16px",
                            minHeight: "28px",
                            "&::placeholder": {
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </SoftBox>

                    <SoftBox width="100%">
                      <SoftTypography
                        fontWeight="bold"
                        fontSize="20px"
                        mb={0.5}
                      >
                        Time Left
                      </SoftTypography>
                      <TextField
                        value={getTimeFromMilliseconds(
                          inspectionDetails?.leftTime
                        )}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDialogue({
                            type: "openTimePicker",
                            isOpen: true,
                            action: "left",
                          });
                        }}
                        name="name"
                        placeholder="Enter Left Time"
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          sx: {
                            border: "1px solid #6A707C",
                            backgroundColor: "#FFFFFF",
                            paddingX: "14px", // Adjust left/right padding
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: "16px",
                            color: "#02255B",
                            paddingY: "16px",
                            minHeight: "28px",
                            "&::placeholder": {
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </SoftBox>
                  </SoftBox>
                </SoftBox>

                <SoftBox
                  display="flex"
                  gap={5}
                  mt="20px"
                  px={3}
                  sx={{
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <SoftBox width="100%">
                    <SoftTypography fontWeight="bold" fontSize="20px" mb={0.5}>
                      Weather Condition
                    </SoftTypography>
                    {/* <TextField
                  value={inspectionDetails?.weather}
                  onChange={(e) =>
                    setInspectionDetails((prev) => ({
                      ...prev,
                      weather: e?.target?.value,
                    }))
                  }
                  name="name"
                  placeholder="Enter Weather"
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    sx: {
                      border: "1px solid #6A707C",
                      backgroundColor: "#FFFFFF",
                      paddingX: "14px", // Adjust left/right padding
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: "16px",
                      color: "#02255B",
                      paddingY: "16px",
                      minHeight: "28px",
                      "&::placeholder": {
                        opacity: 1,
                      },
                    },
                  }}
                /> */}

                    <SoftBox
                      onClick={handleClick}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "9px 12px",
                        border: "0.5px solid #6A707C",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      <SoftTypography
                        fontSize="16px"
                        sx={{
                          padding: "0px 0px 0px 0px",
                          color: "#02255B",
                        }}
                      >
                        {inspectionDetails?.weather}
                      </SoftTypography>
                      {anchorEl == null ? (
                        <IoIosArrowDown
                          size={20}
                          style={{
                            marginLeft: "auto",
                            color: "#02255B",
                          }}
                        />
                      ) : (
                        <IoIosArrowUp
                          size={20}
                          style={{
                            marginLeft: "auto",
                            color: "#02255B",
                          }}
                        />
                      )}
                    </SoftBox>

                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={() => setAnchorEl(null)}
                      PaperProps={{
                        sx: {
                          border: "1px solid #6A707C",
                          borderBottom: "none",
                          padding: 0,
                          borderRadius: "6px",
                          width: anchorEl?.offsetWidth,
                          boxShadow: "0 8px 16px 0 rgba(0, 0, 0, 0.2)",
                        },
                      }}
                    >
                      {["Clear", "Rainy", "Cloudy", "Snow"].map((option) => (
                        <MenuItem
                          key={option}
                          onClick={() => handleMenuItemClick(option)}
                          sx={{
                            borderRadius: 0,
                            padding: "14px 12px",
                            borderBottom: "1px solid #6A707C",
                            fontSize: "14px",
                            color: "primary.main",
                            "&:hover": {
                              backgroundColor: "none !important",
                            },
                          }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                  </SoftBox>

                  <SoftBox
                    display="flex"
                    gap={5}
                    width="100%"
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                    }}
                  >
                    <SoftBox width="100%">
                      <SoftTypography
                        fontWeight="bold"
                        fontSize="20px"
                        mb={0.5}
                      >
                        Temperature(°F):
                      </SoftTypography>
                      <TextField
                        value={inspectionDetails?.temperature}
                        onChange={(e) =>
                          setInspectionDetails((prev) => ({
                            ...prev,
                            temperature: e?.target?.value,
                          }))
                        }
                        name="name"
                        placeholder="Enter Temperature"
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          sx: {
                            border: "1px solid #6A707C",
                            backgroundColor: "#FFFFFF",
                            paddingX: "14px",
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: "16px",
                            color: "#02255B",
                            paddingY: "16px",
                            minHeight: "28px",
                            "&::placeholder": {
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </SoftBox>

                    <SoftBox width="100%">
                      <SoftTypography
                        fontWeight="bold"
                        fontSize="20px"
                        mb={0.5}
                      >
                        Inspection Number
                      </SoftTypography>
                      <TextField
                        value={inspectionDetails?.inspection_number}
                        onChange={(e) => {
                          setInspectionDetails((prev) => ({
                            ...prev,
                            inspection_number: e?.target?.value,
                          }));
                        }}
                        name="name"
                        placeholder="Enter Inspection Number"
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          sx: {
                            border: "1px solid #6A707C",
                            backgroundColor: "#FFFFFF",
                            paddingX: "14px", // Adjust left/right padding
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: "16px",
                            color: "#02255B",
                            paddingY: "16px",
                            minHeight: "28px",
                            "&::placeholder": {
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </SoftBox>
                  </SoftBox>
                </SoftBox>

                {/* Site Representative */}

                <SoftBox
                  px={3}
                  py={2}
                  display="flex"
                  flexDirection="column"
                  gap={2}
                >
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <SoftTypography fontSize="16px" fontWeight="bold">
                      Site Representative
                    </SoftTypography>
                    <SoftButton
                      variant="contained"
                      color="info"
                      sx={{
                        padding: "3px 60px",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                      onClick={() =>
                        setDialogue({
                          type: "addSiteRepresentative",
                          isOpen: true,
                          action: "updateinspection",
                        })
                      }
                    >
                      Add <FaPlus size={12} />
                    </SoftButton>
                  </SoftBox>

                  <SoftBox>
                    {inspectionDetails?.site_representative?.length > 0 &&
                      inspectionDetails?.site_representative?.map(
                        (contact, index) => (
                          <SoftBox
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{
                              backgroundColor: "#F1F4F8",
                              borderRadius: "6px",
                              padding: "5px 8px",
                              marginBottom: "4px",
                              overflowX: "auto",
                              overflowY: "hidden",
                              whiteSpace: "nowrap",
                              scrollbarWidth: "none",
                              "&::-webkit-scrollbar": { display: "none" },
                            }}
                          >
                            <SoftBox
                              display="flex"
                              flexDirection="column"
                              color="primary"
                            >
                              <SoftBox
                                display="flex"
                                alignItems="center"
                                justifyContent="start"
                                gap="8px"
                                py={1}
                              >
                                <SoftTypography
                                  fontSize="14px"
                                  color="primary"
                                  textTransform="uppercase"
                                  fontWeight="medium"
                                >
                                  {contact.name}
                                </SoftTypography>

                                <SoftTypography
                                  fontSize="12px"
                                  color="primary"
                                  textTransform="capitalize"
                                  fontWeight="medium"
                                >
                                  {contact.companyName}
                                </SoftTypography>
                              </SoftBox>
                            </SoftBox>

                            <SoftBox
                              pt={1}
                              display="felx"
                              alignItems="center"
                              justifyContent="center"
                              gap={2}
                            >
                              <DeleteIcon
                                sx={{
                                  cursor: "pointer",
                                  width: "20px",
                                  height: "20px",
                                  color: "error.main",
                                }}
                                onClick={() =>
                                  handleDeleteSiteRepresentative(index)
                                }
                              />

                              <EditIcon
                                sx={{
                                  cursor: "pointer",
                                  width: "20px",
                                  height: "20px",
                                  color: "primary.main",
                                  padding: "2px",
                                  borderRadius: "50%",
                                }}
                                onClick={() =>
                                  handleUpdateSiteRepresentative(index)
                                }
                              />
                            </SoftBox>
                          </SoftBox>
                        )
                      )}
                  </SoftBox>
                </SoftBox>

                {/* Disciplien data */}
                <SoftBox width="100%" px={3}>
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <SoftBox
                      display="flex"
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <SoftTypography fontSize="16px" fontWeight="bold">
                        Select Discipline & Enter Details
                      </SoftTypography>
                    </SoftBox>

                    {(inspectionDetails?.deficiencyFound?.includes("no") ||
                      discipline?.length <= 0) && (
                      <SoftButton
                        variant="contained"
                        color="info"
                        sx={{
                          padding: "3px 40px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                        onClick={() => handleOpenDiciplineSelect(0)}
                      >
                        Discipline <FaPlus size={12} />
                      </SoftButton>
                    )}
                  </SoftBox>
                </SoftBox>

                {discipline && (
                  <SoftBox
                    px={3}
                    py={2}
                    display="flex"
                    flexDirection="column"
                    gap={1}
                  >
                    <InspectionSection
                      discipline={discipline}
                      setDiscipline={setDiscipline}
                      newImages={newImages}
                      deficiencyFound={inspectionDetails?.deficiencyFound}
                    />
                  </SoftBox>
                )}
              </SoftBox>
            )}

            <SoftBox
              py={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <SoftButton
                variant="gradient"
                color="primary"
                disabled={isLoading}
                sx={{
                  padding: "0px",
                  width: "200px",
                  fontSize: "14px",
                  borderRadius: "8px",
                }}
                onClick={handleUpdateInspection}
              >
                {isLoading == true ? <CircularLoader type="small" /> : "Update"}
              </SoftButton>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>

      <SelectDicipline
        discipline={discipline}
        setDiscipline={setDiscipline}
        newImages={newImages}
        setNewImages={setNewImages}
        inspectionDetails={inspectionDetails}
        setInspectionDetails={setInspectionDetails}
      />

      <AddDicipline />
      <AddLocation />
      <SelectInspection
        projectid={projectData?._id}
        referenceData={referenceData}
        setReferenceData={setReferenceData}
        curretnInspectionId={inspectionData?._id}
        setInspectionDetails={setInspectionDetails}
        setDiscipline={setDiscipline}
      />
      <InspectorList setInspectionDetails={setInspectionDetails} />
    </DashboardLayout>
  );
}

export default UpdateInspection;
